export default class AnalyticsHelper {
    public static sendEvent(eventCategory: string, eventAction: string, eventLabel: string) {
        if ((<any>window).ga) {
            (<any>window).ga("send", {
                hitType: "event",
                eventCategory: eventCategory,
                eventAction: eventAction,
                eventLabel: eventLabel
            });
        }
    }

    public static sendPageView(page: string) {
        if ((<any>window).ga) {
            (<any>window).ga("send", {
                hitType: "pageview",
                page: page
            });
        }
    }

    public static ecAddProduct(id: string, name: string, brand: string, category: string, price: number, quantity: number) {
        if ((<any>window).ga) {
            (<any>window).ga("ec:addProduct", {
                id: id,
                name: name,
                brand: brand,
                category: category,
                price: price,
                quantity: quantity
            });
        }
    }

    public static ecSetAction(action: string, actionData: {}) {
        if ((<any>window).ga) {
            if (action === "purchase") {
                (<any>window).ga("set", "&cu", "EUR");
            }

            (<any>window).ga("ec:setAction", action, actionData);
        }
    }
}